module.exports = __webpack_public_path__ + "img/kanban.2d0ba3d5.svg";